import React from 'react';

import Icon from 'components/Misc/Icon';
import { Title } from 'components/Misc/Typography';

const Action = ({ icon, title, subtitle, onClick }) => {
	return (
		<div onClick={onClick} className="p-4 flex flex-col items-center justify-center space-y-2 rounded-lg cursor-pointer border border-neutral-200 hover:border-neutral-300 dark:border-neutral-700 dark:hover:border-neutral-600 transition-colors">
			<Icon
				icon={icon}
				className="w-16 h-16 rounded-full leading-[4rem] text-3xl text-center text-amber-500 bg-amber-500 bg-opacity-20"
			/>

			<Title
				title={title}
				subtitle={subtitle}
				className="text-center"
			/>
		</div>
	);
};

export default Action;